import {BaseContainerModel} from '../base-container.model';
import {
  bl_prt_printable_format_image_hdr_RowInterface, bl_prt_printable_format_image_hdr_RowClass
} from '../../dbschema/index';

export class PrintableFormatImageContainerModel extends BaseContainerModel {
  bl_prt_printable_format_image_hdr: bl_prt_printable_format_image_hdr_RowInterface = new bl_prt_printable_format_image_hdr_RowClass();
}
